import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import * as Mixins from '../mixins';
import cx from 'classnames';
import ContestRow from './ContestRow';

const ContestSchedule = (props) => {
  const StyledContestScheduleWrapper = styled.div`
    background: ${Mixins.palette.black};
    padding: 3rem 0;
    ${Mixins.mq('tablet')} {
      padding: 5rem 0;
    }
    .contest_schedule__header {
      padding: 0 1rem;
      & > * {
        text-align: center;
        color: ${Mixins.palette.white};
      }
      .headline {
        padding-bottom: 0.5rem;
      }
      .richtext__body {
        width: 100%;
        max-width: 700px;
        margin: 0 auto;
      }
    }
    .contest_schedules {
      display: block;
      width: 100%;
      max-width: 450px;
      margin: 0 auto;
      background: #161616;
      ${Mixins.mq('tablet')} {
        padding: 1.5%;
        max-width: 1100px;
      }
    }
    .contest_row {
      ${Mixins.mq('tablet')} {
        ${Mixins.dFlex}
        ${Mixins.flexDirection('row')}
            ${Mixins.justifyContent('flex-start')}
            ${Mixins.alignItems('center')}
      }
    }
    .contest_row__item {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #737b7d;
      &.hide {
        display: none;
      }
      &--date {
        ${Mixins.mq('tablet')} {
          width: 15%;
        }
      }
      &--event {
        color: ${Mixins.palette.white};
        ${Mixins.mq('tablet')} {
          width: 40%;
        }
      }
      &--entry {
        ${Mixins.dFlex}
        ${Mixins.flexDirection('row')}
            ${Mixins.justifyContent('flex-start')}
            ${Mixins.alignItems('center')}
            ${Mixins.mq('tablet')} {
          width: 15%;
        }
      }
      &--prize {
        ${Mixins.mq('tablet')} {
          width: 20%;
        }
      }
      &--link {
        padding-top: 0.5rem;
        a {
          display: block;
          font-family: 'Open Sans Condensed', sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 18px;
          line-height: 1;
          color: ${Mixins.palette.greenTwo};
          z-index: 10;
          position: relative;
        }
        ${Mixins.mq('tablet')} {
          width: 10%;
        }
      }
      &--hide_in_desktop {
        ${Mixins.mq('tablet')} {
          display:none;
        }
      }
      &--hide_in_mobile {
        display:none;
        ${Mixins.mq('tablet')} {
          display: block;
        }
      }
    }
    .contest_schedules__header {
      display: none;
      border-bottom: 2px solid #272727;
      .contest_row {
        font-weight: 600;
        font-size: 16px;
        line-height: 1.4;
        letter-spacing: 0.2px;
        color: ${Mixins.palette.white};
        padding-bottom: 1rem;
        &__item {
          color: ${Mixins.palette.white};
        }
      }
      ${Mixins.mq('tablet')} {
        display: block;
        padding: 0 0.75rem;
      }
    }
    .contest_schedule__filter_container {
      text-align: center;
      padding: 2rem 0;
      ${Mixins.mq('tablet')} {
        padding: 3rem 0;
      }
      &__select {
        font-family: Open Sans, sans-serif;

        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.3;
        padding: 0.5rem 1.25rem;
        position: relative;
        ${Mixins.mq('tablet')} {
          display: none;
        }
      }
      &__buttons {
        display: none;
        ${Mixins.mq('tablet')} {
          ${Mixins.dFlex}
          ${Mixins.flexDirection('row')}
                ${Mixins.justifyContent('center')}
                ${Mixins.alignItems('center')}
        }
      }
    }
    .button_filter {
      font-family: Open Sans, sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      text-align: center;
      letter-spacing: 0.1px;
      color: ${Mixins.palette.white};
      background: #272727;
      border: 1px solid ${Mixins.palette.black};
      padding: 0.5rem 1.25rem;
      cursor: pointer;
      &.active {
        background: ${Mixins.palette.white};
        color: ${Mixins.palette.black};
        cursor: default;
      }
    }
    .contest_row_container {
      padding: 0.75rem;
      &:nth-of-type(odd) {
        background: ${Mixins.palette.black};
      }
      &:nth-of-type(even) {
        background: #161616;
      }
      ${Mixins.mq('tablet')} {
        padding: 0.55rem 0.75rem;
        &:nth-of-type(even) {
          background: #161616;
        }
        &:nth-of-type(odd) {
          background: #161616;
        }
      }
    }
  `;

  const verticalFilters = [
    { key: 'Upcoming', label: 'All Events' },
    { key: 'Past', label: 'Past Events' },
  ];

  const [activeFilter, setActiveFilter] = useState('Upcoming');
  const [contestData, setContestData] = useState(props.contest_event.filter((event) => event.event_type !== 'Past'));

  const allContestData = props.contest_event;

  useEffect(() => {
    let contestEventData;

    if (activeFilter === 'Upcoming') {
      contestEventData = props.contest_event.filter((contest) => contest.event_type !== 'Past');
    } else if (activeFilter === 'Past') {
      contestEventData = props.contest_event.filter((contest) => contest.event_type === 'Past');
    }

    setContestData(contestEventData);
  }, [activeFilter, props.contest_event, allContestData]);

  return (
    <StyledContestScheduleWrapper className="contest_schedule">
      <div className="contest_schedule__header">
        <h2 className="headline">{props.headline}</h2>
        <div
          className="richtext__body"
          dangerouslySetInnerHTML={{ __html: props.body }}
        ></div>
      </div>

      <div className="contest_schedule__filter_container">
        <select
          className="contest_schedule__filter_container__select"
          onChange={(e) => setActiveFilter(e.currentTarget.value)}
          onBlur={(e) => setActiveFilter(e.currentTarget.value)}
        >
          {verticalFilters.map(({ key, label }, verticalIdx) =>
            key === activeFilter ? (
              <option
                value={key}
                key={`options_${key}_${verticalIdx}`}
                selected
              >
                {label}
              </option>
            ) : (
              <option
                value={key}
                key={`options_${key}_${verticalIdx}`}
              >
                {label}
              </option>
            )
          )}
        </select>
        <div className="contest_schedule__filter_container__buttons">
          {verticalFilters.map(({ key, label }, verticalIdx) => (
            <button
              className={cx('button_filter', { active: activeFilter === key })}
              value={key}
              key={`button_${key}_${verticalIdx}`}
              onClick={(e) => {
                setActiveFilter(e.currentTarget.value);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="contest_schedules">
        <div className="contest_schedules__header">
          <div className={cx('contest_row')}>
            <div className="contest_row__item contest_row__item--date">End Date</div>
            <div className="contest_row__item contest_row__item--event">Event</div>
            <div
              className={cx('contest_row__item--entry', 'contest_row__item', {
                hide: activeFilter === 'Past',
              })}
            >
              Entry Fee
            </div>
            <div
              className={cx('contest_row__item--prize', 'contest_row__item', {
                hide: activeFilter === 'Past',
              })}
            >
              Total Prizes
            </div>
            <div
              className={cx(
                'contest_row__item--prize',
                'contest_row__item',
                { hide: activeFilter !== 'Past' },
                { 'contest_row__item--winner': activeFilter === 'Past' }
              )}
            >
              Winner
            </div>
          </div>
        </div>
        {contestData.map((item, itemKey) => {
          return <ContestRow
            data={item}
            activeFilter={activeFilter}
            key={itemKey}
          ></ContestRow>;
        })}
      </div>
    </StyledContestScheduleWrapper>
  );
};

export default ContestSchedule;
